import { Input } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import React from 'react'

const DemandeExpressEditor: React.FC<TextAreaProps> = ({ value, onChange }) => {
  return <Input.TextArea onChange={onChange} value={value} />
}

export default DemandeExpressEditor
